/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ZapOffIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="zap-off"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M20.21 2.5L10 2.5L4.29 12.5L10.29 12.5L8.29 21.5L19.79 9.5L16 9.5L20.21 2.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M2.5 2.5L21.5 21.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
